import { DependencyList, EffectCallback, useEffect, useRef } from 'react';

export function useUpdateEffect(fn: EffectCallback, deps?: DependencyList) {
  const isMounting = useRef(true);
  useEffect(() => {
    if (isMounting.current) {
      isMounting.current = false;
      return undefined;
    }
    return fn();
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, deps);
}
